export default __webpack_public_path__ + "static/media/flume.8eadefce.jpg";